import React, { useEffect, useState } from 'react';
import { View, Text,  StyleSheet, StatusBar, TouchableOpacity, Platform } from 'react-native';

import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons"
import { getProfileinfo, logOut } from '../store/action/userLogin';
import { useDispatch, useSelector } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { NativeBaseProvider, useMediaQuery } from 'native-base';










const Order = (props) => {
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    
    const [task, setTask] = useState("");

    const getprofileHandler = async () => {
        try {

            const res = await dispatch(getProfileinfo(tokens));
            //console.log(res.data.data.user);
            setTask(res.data.data.user)


        } catch (err) {
            // logOutHandler();
        }
    }


    
    useEffect(() => {
     
        getprofileHandler()
    }, [])



   

    const logOutHandler = async () => {
        try {
        //   console.log("logout");
          await dispatch(logOut());
          await AsyncStorage.removeItem("access_token");
          props.navigation.navigate("splash");
        } catch (err) {
          console.log(err);
        }
      };


      const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth:500
      });

    return (

<NativeBaseProvider>


        <View style={{
       width:isSmallScreen ?"100%":500 ,
        height: "100%",
        marginLeft: isSmallScreen ? 0 : "35%",
        backgroundColor: Colors.background,
        position:Platform.OS=="web"?"fixed":"relative"
    }}>
  

            <View style={styles.viewHeader}>
                <StatusBar backgroundColor={Colors.primary} />
                <TouchableOpacity  onPress={() => props.navigation.goBack()}style={styles.menu}   >
                    <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                </TouchableOpacity>

                <TouchableOpacity  onPress={() => props.navigation.goBack()}style={styles.textheader}>
                    <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                        ثبت سفارش
                    </Text>
                </TouchableOpacity>

            </View>



            <View style={styles.viewlogo}>
                <Text style={styles.texttitel}>ابتدا یکی از روش های زیر را انتخاب کنید</Text>
                <Text style={styles.text}>پیشنهاد ما به شما <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.primary }}> ثبت سفارش سریع </Text> است که به صورت</Text>
                <Text style={{ fontFamily: "Montserrat", fontSize: 14, color: Colors.secondText3, }}>دقیق وسریع میتوانید فرایند ثبت سفارش خود را انجام دهید</Text>
            </View>


            <TouchableOpacity onPress={() => {

                if (task.status =="false") {
                    props.navigation.navigate("ordercolor")
                } else {
                    props.navigation.navigate("form", {
                        image: "",
                        orderid:""
                    })
                }
            }}

                style={styles.touch}>
                <View style={styles.viewicon}>
                    <MaterialCommunityIcons name="clipboard-text-multiple-outline" size={45} color={Colors.primary} />
                </View>

                <Text style={styles.texttouch}>ثبت سریع (برش ونوار)</Text>
                <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3, marginTop: "1%" }}>ارسال اطلاعات سفارش از طریق فرم به صورت دقیق وبا سرعت بالا</Text>
            </TouchableOpacity>

            <TouchableOpacity onPress={() => props.navigation.navigate("service", {
                number: "2",
                ostany: task.state_id,
                citys: task.city_id
            })} style={styles.touch}>
                <View style={styles.viewicon}>
                    <MaterialCommunityIcons name="wechat" size={50} color={Colors.primary} />
                </View>

                <Text style={styles.texttouch}>ثبت پیشرفته (سایر خدمات)</Text>
                <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.secondText3, bottom: 5 }}>ارسال اطلاعات سفارش به صورت سیستم چت با سرعت بالا</Text>
                <Text style={{ fontFamily: "Montserrat", fontSize: 11, color: Colors.secondText3, bottom: 6 }}>وکیوم ، cnc و غیره...</Text>
            </TouchableOpacity>




        </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position:Platform.OS=="web"?"fixed":"relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height:Platform.OS=="web"?60: 80,
        backgroundColor: Colors.primary,
    },

    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS=="web"?"15%":"35%",

    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 100,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "12%",
        top:Platform.OS=="web"?"15%": "35%"
    },
    viewlogo: {
        width: "100%",
        height: 100,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "10%"
    },
   
    
    texttitel: {
        fontFamily: "MontserratBold",
        fontSize: 20,
        bottom: 80,
        position: "absolute"
    },
    text: {
        fontFamily: "Montserrat",
        fontSize: 14,
        color: Colors.secondText3,
        textAlign: "right",
        marginTop: 30,
    },
    touch: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%", height: 170,
        backgroundColor: Colors.background1,
        marginTop: 20,
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3


    },
    viewicon: {
        width: 90, height: 90,
        backgroundColor: Colors.RGB,
        borderRadius: 45,
        marginTop: "3%",
        alignItems: "center",
        justifyContent: "center"
    },
    texttouch: {
        fontFamily: "MontserratBold",
        fontSize: 15,
        color: Colors.primary,
        marginTop: "1%"
    }
})




export default Order